"use client";

import { RouteError } from "@/components/shared/route-error";

export default function ShowsError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	return (
		<RouteError
			error={error}
			reset={reset}
			context="Shows"
			description="We encountered an error while loading shows. This might be temporary."
			fallbackUrl="/shows"
			fallbackLabel="Refresh page"
		/>
	);
}
